import React from "react";
import { Alert, Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { normalizeIdArray } from "../utils/companyUtils";
import { AwardIcon } from "../../../utils/awardIcons";

export default function SectionAuszeichnungen({
                                                  form,
                                                  setForm,
                                                  awards,
                                                  awardsLoading,
                                                  awardsError,
                                              }) {
    const activeAwards = React.useMemo(
        () => (awards || []).filter((award) => award.is_active === undefined || !!award.is_active),
        [awards]
    );

    const selectedIds = normalizeIdArray(form.award_ids);

    const toggleAward = (id) => {
        setForm((f) => {
            const ids = new Set(normalizeIdArray(f.award_ids));
            if (ids.has(id)) ids.delete(id);
            else ids.add(id);
            return { ...f, award_ids: Array.from(ids).sort((a, b) => a - b) };
        });
    };

    if (awardsError) return <Alert severity="error">{awardsError}</Alert>;

    if (awardsLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!activeAwards.length) {
        return <Alert severity="info">Keine Auszeichnungen vorhanden. Lege zuerst Auszeichnungen an.</Alert>;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {selectedIds.length} von {activeAwards.length} ausgewählt
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        lg: "repeat(3, minmax(0, 1fr))",
                    },
                    gap: 0.5,
                }}
            >
                {activeAwards.map((award) => {
                    const id = Number(award.id);
                    const checked = selectedIds.includes(id);
                    return (
                        <FormControlLabel
                            key={award.id}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleAward(id)}
                                    sx={{ py: 0.5 }}
                                />
                            }
                            label={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                                    <AwardIcon iconText={award.icon_text} size={22} />
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                    >
                                        {award.label_de || award.name}
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                m: 0,
                                minWidth: 0,
                                borderRadius: 1,
                                px: 0.75,
                                py: 0.35,
                                bgcolor: checked ? "rgba(240, 172, 77, 0.10)" : "transparent",
                                "&:hover": { bgcolor: "action.hover" },
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
